import _loadjs from 'loadjs';
import { WeaTools } from 'ecCom';

export const loadModule = ({ module, files = [], async = false, success, error }) => {
  const loadjs = window.loadjs || _loadjs;
  loadjs.isDefined(module)
    ? loadjs.ready(module, { success, error })
    : loadjs(files, module, { async, success, error });
};

export const registerComs = () => {
  if (!window.e9_registed_coms && !window.e9_registed_coms_loading) {
    window.e9_registed_coms_loading = true;
    WeaTools.callApi('/api/system/componentmanage/queryComponentByComtype').then((data) => {
      if (data.status && data.datas) {
        data.datas.forEach((cof) => {
          if (cof.id) {
            var libs = cof.url.split(',');
            for (let index = 0; index < libs.length; index++) {
              const element = libs[index];
              if (window.ecologyContentPath && !new RegExp(window.ecologyContentPath).test(element)) {
                libs[index] = window.ecologyContentPath + element;
              }
            }
            window.eventRegister.register(cof.id, {
              lib: libs,
              libName: cof.name,
              fn() {
                return 'success';
              },
            });
          }
        });
        window.e9_registed_coms = true;
        window.e9_registed_coms_loading = false;
      }
    });
  }
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/util/loadjsUtil.js